import React from 'react'
import InventoryFieldsRowForCardTypeBoth from './InventoryFieldsRowForCardTypeBoth'

/**
 * InventorySectionForCardTypeBoth component - Section for Cash/Product/Physical reward types
 * Contains inventory fields (quota, leftover inventory, limit per store)
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing inventory fields
 * @param {Function} props.handleFormChange - Function to handle form field changes
 * @param {Function} props.handleValidation - Function to handle validation state
 * @param {Function} props.handleQuotaDigitalCardChange - Function to handle quota digital card field changes
 * @param {Function} props.handleLeftoverInventoryDigitalCardChange - Function to handle leftover inventory digital card field changes
 * @param {Function} props.handleLimitPerStoreDigitalCardChange - Function to handle limit per store digital card field changes
 * @param {Function} props.handleQuotaPhysicalCardChange - Function to handle quota physical card field changes
 * @param {Function} props.handleLeftoverInventoryPhysicalCardChange - Function to handle leftover inventory physical card field changes
 * @param {Function} props.handleLimitPerStorePhysicalCardChange - Function to handle limit per store physical card field changes
 * @param {boolean} props.isQuotaDigitalCardDisabled - Whether quota digital card field should be disabled
 * @param {boolean} props.isQuotaPhysicalCardDisabled - Whether quota physical card field should be disabled
 * @param {string} props.quotaDigitalCardValidationError - Validation error message for quota digital card field
 * @param {string} props.quotaPhysicalCardValidationError - Validation error message for quota physical card field
 * @param {string} props.limitPerStoreDigitalCardValidationError - Validation error message for limit per store digital card field
 * @param {string} props.limitPerStorePhysicalCardValidationError - Validation error message for limit per store physical card field
 * @returns {JSX.Element} The rendered InventorySectionForCardTypeBoth component
 */
const InventorySectionForCardTypeBoth = ({
  formData,
  handleFormChange,
  handleValidation,
  handleQuotaDigitalCardChange,
  handleLeftoverInventoryDigitalCardChange,
  handleLimitPerStoreDigitalCardChange,
  handleQuotaPhysicalCardChange,
  handleLeftoverInventoryPhysicalCardChange,
  handleLimitPerStorePhysicalCardChange,
  isQuotaDigitalCardDisabled,
  isQuotaPhysicalCardDisabled,
  quotaDigitalCardValidationError,
  quotaPhysicalCardValidationError,
  limitPerStoreDigitalCardValidationError,
  limitPerStorePhysicalCardValidationError
}) => {

  return (
    <InventoryFieldsRowForCardTypeBoth
      formData={formData}
      handleFormChange={handleFormChange}
      handleValidation={handleValidation}
      handleQuotaDigitalCardChange={handleQuotaDigitalCardChange}
      handleLeftoverInventoryDigitalCardChange={handleLeftoverInventoryDigitalCardChange}
      handleLimitPerStoreDigitalCardChange={handleLimitPerStoreDigitalCardChange}
      handleQuotaPhysicalCardChange={handleQuotaPhysicalCardChange}
      handleLeftoverInventoryPhysicalCardChange={handleLeftoverInventoryPhysicalCardChange}
      handleLimitPerStorePhysicalCardChange={handleLimitPerStorePhysicalCardChange}
      isQuotaDigitalCardDisabled={isQuotaDigitalCardDisabled}
      isQuotaPhysicalCardDisabled={isQuotaPhysicalCardDisabled}
      quotaDigitalCardValidationError={quotaDigitalCardValidationError}
      quotaPhysicalCardValidationError={quotaPhysicalCardValidationError}
      limitPerStoreDigitalCardValidationError={limitPerStoreDigitalCardValidationError}
      limitPerStorePhysicalCardValidationError={limitPerStorePhysicalCardValidationError}
    />
  )
}

export default InventorySectionForCardTypeBoth
